import { Col, Form, FormInstance, Input, Row, Spin, Switch } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import type { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/theme_components/DataGrid';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notification from 'components/theme_components/Notifications';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import { getSiloBrandList, TpSiloResponse } from 'services/thirdParty';
import { toCurrency } from 'utils/utils';
import { useQuery } from 'react-query';
import { setValueByNamePath } from 'utils/utilsSFS';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';

export type TabInterBrandProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  loading: boolean;
  objectid: number;
  prcodeProps: string;
  dataInput: any;
  funcode: string;
  tptype: string;
};

const TabInterBrand = ({
  form,
  onDone,
  onCancel,
  loading,
  objectid,
  prcodeProps,
  dataInput,
  funcode,
  tptype,
}: TabInterBrandProps) => {
  const fieldName = 'silointraList';
  const [modalVisible, setModalVisible] = useState(false);
  const { isInspect } = useContext(AuthContext);

  const { data: siloList, isLoading } = useQuery(
    ['getSiloBrandListSILOINTRAM', objectid, prcodeProps],
    () =>
      getSiloBrandList({
        silotpid: objectid,
        siloprcode: prcodeProps,
        silotype: 'SILOINTRA',
      }).then((res) => {
        return res.list || [];
      }),
    { enabled: objectid != null, refetchOnWindowFocus: false }
  );

  useEffect(() => {
    if (siloList) {
      let newlistsiloList = siloList;
      if (dataInput) {
        newlistsiloList = siloList?.map((silo: any) => {
          if (silo.silointerbrandid == dataInput?.siloid) {
            console.log('silo', silo);
            silo.siloselected = true;
          }
          return silo;
        });

        form.setFieldsValue({
          event: funcode,
          [fieldName]: newlistsiloList,
          prcode: prcodeProps,
          siloid: dataInput?.siloid,
          silolabel: dataInput.silolabel,
        });
      } else {
        form.setFieldsValue({
          event: funcode,
          [fieldName]: siloList,
          prcode: prcodeProps,
        });
      }
    } else {
      form.setFieldsValue({
        event: funcode,
        prcode: prcodeProps,
        [fieldName]: [],
      });
    }
  }, [siloList]);

  const columns: any[] = [
    {
      dataIndex: 'silobrand',
      className: 'font-size-15 font-weight-500',
      width: '50%',
    },
    {
      align: 'right',
      dataIndex: 'siloavailbleamount',
      render: (value: any) => toCurrency(value),
      className: 'font-size-15',
    },
    {
      align: 'right',
      title: 'Percentage',
      className: 'font-size-15',
      render: (record: any) => {
        // FIXED: Get percentage from tpAuthorizationResponses instead of hardcoded 0%
        if (record.tpAuthorizationResponses && record.tpAuthorizationResponses.length > 0) {
          // Calculate average percentage if multiple authorizations exist
          const totalPercentage = record.tpAuthorizationResponses.reduce((sum: number, auth: any) => {
            return sum + (auth.pourcentageConsumedNLimit || 0);
          }, 0);
          const averagePercentage = totalPercentage / record.tpAuthorizationResponses.length;
          return <>{averagePercentage.toFixed(2)}%</>;
        }
        return <>0.00%</>;
      },
    },
    {
      align: 'left',
      dataIndex: 'actions',
      className: 'font-size-15',
      width: '9%',
      render: (_: any, record: any, index: number) => {
        //let disabled = record?.silointerbrandid == dataInput?.siloid ? false : record?.silointerbrandid != null || record.silostatus !== 'ACTIVE';
        let disabled =
          record?.silostatus !== 'ACTIVE'
            ? true
            : record?.silointerbrandid !== dataInput?.siloid &&
              record?.silointerbrandid != null;

        console.log('disabled', disabled);
        return (
          <Form.Item
            name={[fieldName, index, 'siloselected']}
            initialValue={record.siloselected}
            noStyle
          >
            <Switch
              className={
                disabled
                  ? 'custom-switch custom-switch-disabled'
                  : 'custom-switch'
              }
              onChange={(e) => {
                setValueByNamePath(form, [fieldName, index, 'siloselected'], e);
              }}
              disabled={disabled}
            />
          </Form.Item>
        );
      },
    },
  ];

  return (
    <div className="intermarque-modal">
      <FormInput
        col
        md={24}
        name="silolabel"
        className="no-border-radius ut-input-modal-silos mt-5 mb-9"
        rules={[{ required: true }]}
        labelCol={{ span: 24 }}
        layout="vertical"
      >
        <Input />
      </FormInput>

      <Form.Item shouldUpdate>
        {({ getFieldValue, getFieldsValue }) => {
          console.log('fieldName', getFieldValue(fieldName));
          const siloslist = getFieldValue(fieldName) ?? [];
          let selectedSilo = siloslist.filter((silo: any) => silo.siloselected);
          console.log('selectedSilo', selectedSilo);
          return (
            <Spin spinning={isLoading}>
              <DataGrid
                columns={columns}
                dataSource={getFieldValue(fieldName)}
                rowKey={(record) => record.siloid}
                hideFilters
                hideTitle
              />
            </Spin>
          );
        }}
      </Form.Item>

      <Row justify="end" gutter={8} className="modal-footer">
        <ButtonLink
          comcode="close"
          className="close-btn"
          onClick={() => {
            !isInspect && onCancel();
          }}
        />

        <Form.Item shouldUpdate>
          {({ getFieldValue, getFieldsValue }) => {
            console.log('fieldName', getFieldValue(fieldName));
            const siloslist = getFieldValue(fieldName) ?? [];
            let selectedSilo = siloslist.filter(
              (silo: any) => silo.siloselected
            );
            return (
              <ButtonLink
                type="primary"
                comcode="Valider"
                htmlType="submit"
                className="ut-submit-btn ml-2"
                iconPosition="end"
                disabled={isLoading}
                loading={loading}
                onClick={() => {
                  !isInspect &&
                    form.validateFields().then(() => {
                      if (selectedSilo.length <= 1) {
                        setModalVisible(true);
                      } else {
                        onDone();
                      }
                    });
                }}
              />
            );
          }}
        </Form.Item>

        <ConfirmModal
          visible={modalVisible}
          status="error"
          message="Vous devez choisir au minimum deux silos intra-marque."
          onConfirm={() => {
            setModalVisible(false);
          }}
          onCancel={() => setModalVisible(false)}
          onlyCancel
          onlyConfirm
          className="modalConfirmOrCancel"
        />
      </Row>
    </div>
  );
};

export default TabInterBrand;